module.exports = __webpack_public_path__ + "media/images/webpage/shared/checklist/excellent-ddde98b3480b98e401c7daf473686375.svg";